export default __webpack_public_path__ + "static/media/owl.80dc697f.svg";